export default "__VITE_ASSET__DHEysq7Q__"